import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import './Disable-Popup.scss';
import { Button } from '@material-ui/core';

function getModalStyle() {
  const top = 50;
  const left = 75.5;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    height: 200,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(5, 4, 3),
  },
}));

const DisablingPopupModel = (props) => {
  const { disablePopUp, onDisabling, onDisablingCancel } = props;
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const handleClose = () => {
    onDisablingCancel();
  };

  const onDeleteClick = (e) => {
    onDisabling(e);
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className='disabling-popup'>
        <div className='disabling-popup-title'>
          {disablePopUp.title}
          <div>{disablePopUp.name}?</div>
        </div>
        <div className='col-md-10 offset-1 d-flex justify-content-around mt-4'>
          <Button
            variant='outlined'
            size='large'
            color='secondary'
            className='disabling-popup-button-size'
            onClick={(e) => handleClose()}
          >
            No
          </Button>
          <Button
            variant='contained'
            size='large'
            color='primary'
            className='disabling-popup-button-size'
            onClick={(e) => onDeleteClick(e)}
          >
            Yes
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Modal open={disablePopUp.isActive} onClose={handleClose}>
        {body}
      </Modal>
    </div>
  );
};

export default DisablingPopupModel;
